import React from 'react'
import { Box, Typography, Divider } from '@mui/material'
import PersonLogin from '../../../../Assets/login.png'

const SolutionsSection: React.FC = () => {
  return (
    <Box
      sx={{
        display: { xs: 'none', md: 'none', lg: 'block' },
      }}
    >
      <Box
        component="img"
        src={PersonLogin}
        alt=""
        sx={{
          width: '100%',
          height: '100vh',
          objectFit: 'fill',
          objectPosition: 'center center',
            maxWidth: '100vw', // Limita a largura ao tamanho da viewport
            maxHeight: '100vh'  // Limita a altura ao tamanho da viewport
        }}
      />
    </Box>
  )
}

export default SolutionsSection
